(() => {
  if (window.__assistcoCrossSellReady) return;
  window.__assistcoCrossSellReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
  const addItems = async (id, quantity) => {
    let lastError;
    for (let attempt = 1; attempt <= 3; attempt += 1) {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
      });
      if (response.ok) return response.json();
      const payload = await response.json().catch(() => ({}));
      lastError = new Error(payload.description || payload.message || 'Kunne ikke legge varen i handlekurven.');
      if (response.status !== 429 || attempt === 3) throw lastError;
      const retryAfter = Math.max(800, Math.min(5000, Number(response.headers.get('Retry-After') || 1) * 1000));
      await wait(retryAfter);
    }
    throw lastError;
  };
  const chooseBottleDealQuantity = (button) => {
    const form = button.closest('form[action*="/cart/add"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const status = form?.querySelector('[data-bottle-deal-status]');
    const quantity = Math.max(1, Number(button.dataset.bottleDealQuantity || 5));
    if (!quantityInput) {
      if (status) status.textContent = 'Velg antall 5 i feltet over.';
      return;
    }
    quantityInput.value = String(quantity);
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    button.setAttribute('aria-pressed', 'true');
    button.textContent = quantity === 5 ? '5 flasker valgt ✓' : `${quantity} flasker valgt ✓`;
    if (status) status.textContent = 'Klart – velg ønsket farge og legg i handlekurven.';
    form.querySelector('button[name="add"], .add-to-cart-button')?.focus({ preventScroll: true });
  };
  document.addEventListener('click', async (event) => {
    const bottleDealButton = event.target.closest('[data-bottle-deal-quantity]');
    if (bottleDealButton) {
      chooseBottleDealQuantity(bottleDealButton);
      return;
    }
    const button = event.target.closest('[data-cross-sell-add]');
    if (!button) return;
    const card = button.closest('.nlp-cross-sell__card');
    const variant = card?.querySelector('[data-cross-sell-variant]');
    const status = card?.querySelector('[data-cross-sell-status]');
    const quantity = Math.max(1, Number(button.dataset.quantity || 1));
    if (!variant?.value) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = quantity === 5 ? 'Legger til fem flasker …' : 'Legger til …';
    if (status) status.textContent = '';
    try {
      const result = await addItems(variant.value, quantity);
      button.textContent = quantity === 5 ? '5 flasker lagt til ✓' : 'Lagt til ✓';
      if (status) status.innerHTML = 'Klart! <a href="' + root + 'cart">Se handlekurven</a>';
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'navnlapp_cross_sell', result } }));
      window.dispatchEvent(new CustomEvent('assistco:cart-added', { detail: result }));
      if (button.closest('[data-context="cart"]')) window.setTimeout(() => window.location.reload(), 650);
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      if (status) status.textContent = error?.message || 'Noe gikk galt. Prøv igjen.';
    }
  });
})();
